var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavInvoicesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.66667 10.6667H5.33333",
    stroke: "#525252",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.33333 5.33333H5.33333",
    stroke: "#525252",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.6667 8H5.33333",
    stroke: "#525252",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M2.66667 2C2.66667 1.82319 2.7369 1.65362 2.86193 1.5286C2.98695 1.40357 3.15652 1.33333 3.33333 1.33333C3.49841 1.33243 3.66032 1.37868 3.8 1.46667L4.422 1.86667C4.56136 1.95572 4.72329 2.00304 4.88867 2.00304C5.05405 2.00304 5.21598 1.95572 5.35533 1.86667L5.978 1.46667C6.11736 1.37762 6.27929 1.3303 6.44467 1.3303C6.61005 1.3303 6.77198 1.37762 6.91133 1.46667L7.53333 1.86667C7.67269 1.95572 7.83462 2.00304 8 2.00304C8.16538 2.00304 8.32731 1.95572 8.46667 1.86667L9.08867 1.46667C9.22802 1.37762 9.38995 1.3303 9.55533 1.3303C9.72071 1.3303 9.88264 1.37762 10.022 1.46667L10.6447 1.86667C10.784 1.95572 10.946 2.00304 11.1113 2.00304C11.2767 2.00304 11.4386 1.95572 11.578 1.86667L12.2 1.46667C12.3397 1.37868 12.5016 1.33243 12.6667 1.33333C12.8435 1.33333 13.013 1.40357 13.1381 1.5286C13.2631 1.65362 13.3333 1.82319 13.3333 2V14C13.3333 14.1768 13.2631 14.3464 13.1381 14.4714C13.013 14.5964 12.8435 14.6667 12.6667 14.6667C12.5016 14.6676 12.3397 14.6213 12.2 14.5333L11.578 14.1333C11.4386 14.0443 11.2767 13.997 11.1113 13.997C10.946 13.997 10.784 14.0443 10.6447 14.1333L10.022 14.5333C9.88264 14.6224 9.72071 14.6697 9.55533 14.6697C9.38995 14.6697 9.22802 14.6224 9.08867 14.5333L8.46667 14.1333C8.32731 14.0443 8.16538 13.997 8 13.997C7.83462 13.997 7.67269 14.0443 7.53333 14.1333L6.91133 14.5333C6.77198 14.6224 6.61005 14.6697 6.44467 14.6697C6.27929 14.6697 6.11736 14.6224 5.978 14.5333L5.35533 14.1333C5.21598 14.0443 5.05405 13.997 4.88867 13.997C4.72329 13.997 4.56136 14.0443 4.422 14.1333L3.8 14.5333C3.66032 14.6213 3.49841 14.6676 3.33333 14.6667C3.15652 14.6667 2.98695 14.5964 2.86193 14.4714C2.7369 14.3464 2.66667 14.1768 2.66667 14V2Z",
    stroke: "#525252",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavInvoicesIcon);
export default __webpack_public_path__ + "static/media/nav-invoices-icon.01a62e70060c5beda79108dce87591fd.svg";
export { ForwardRef as ReactComponent };